const flattenAppContext = (context, initialObject = {}) => {
    const flatObject = initialObject;
    if (!context)
        return flatObject;
    Object.keys(context).forEach((key) => {
        const value = context[key];
        if (value instanceof Function) {
            if (key.startsWith('get') || key.startsWith('is')) {
                const keyWithoutAccessor = key.replace(/^get|is/, '');
                const firstCharLowerCase = keyWithoutAccessor[0].toLowerCase();
                flatObject[firstCharLowerCase + keyWithoutAccessor.substring(1)] = value();
            }
            return;
        }
        if (key !== 'config') {
            flatObject[key] = value;
        }
    });
    return flatObject;
};
export { flattenAppContext };
